(function () {

  function initCartDrawer() {

    const drawer = document.getElementById('CartDrawer');

    if (!drawer) return;

      const itemsContainer = drawer.querySelector('#CartDrawerItems');
      const subtotalElement = drawer.querySelector('#CartDrawerSubtotal');
      const footerElement = drawer.querySelector('#CartDrawerFooter');

    /*
     * ==============================
     * OPEN / CLOSE
     * ==============================
     */

    function openCartDrawer() {
      drawer.classList.add('is-open');
      document.body.classList.add('cart-drawer-open');
    }

    function closeCartDrawer() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-open');
    }


    /*
     * ==============================
     * CLOSE BUTTONS
     * ==============================
     */

    drawer.addEventListener('click', function (event) {

      if (event.target.closest('[data-cart-close]')) {
        closeCartDrawer();
        return;
      }

    });


    /*
     * ==============================
     * ADD TO CART
     * ==============================
     */

    document.addEventListener('submit', async function (event) {

      const form = event.target;

      if (!form.matches('form[action*="/cart/add"]')) {
        return;
      }

      event.preventDefault();

      const formData = new FormData(form);

      try {

        const response = await fetch(
          window.Shopify.routes.root + 'cart/add.js',
          {
            method: 'POST',
            headers: {
              'Accept': 'application/json'
            },
            body: formData
          }
        );

        if (!response.ok) {
          throw new Error('Unable to add product');
        }

        await response.json();

        /*
         * Only ONE cart request.
         * Do not call cart/add.js -> cart.js -> another request.
         */

        await loadCart();

        openCartDrawer();

      } catch (error) {

        console.error('Add to cart error:', error);

      }

    });


    /*
     * ==============================
     * LOAD CART
     * ==============================
     */

    async function loadCart() {

      try {

        const response = await fetch(
          window.Shopify.routes.root + 'cart.js',
          {
            headers: {
              'Accept': 'application/json'
            }
          }
        );

        if (!response.ok) {
          throw new Error('Unable to load cart');
        }

        const cart = await response.json();

        renderCart(cart);

        return cart;

      } catch (error) {

        console.error('Cart loading error:', error);

      }

    }


    /*
     * ==============================
     * CART CLICK HANDLER
     *
     * Event delegation.
     * We only need ONE listener.
     * ==============================
     */

    itemsContainer.addEventListener('click', function (event) {

      const plusButton = event.target.closest('.cart-quantity-plus');
      const minusButton = event.target.closest('.cart-quantity-minus');
      const removeButton = event.target.closest('.cart-remove');

      /*
       * PLUS
       */

      if (plusButton) {

        const item = plusButton.closest('.cart-drawer__item');

        if (!item) return;

        const quantityElement =
          item.querySelector('.cart-quantity-number');

        const quantity =
          parseInt(quantityElement.textContent, 10) || 0;

        updateCartItem(
          plusButton.dataset.key,
          quantity + 1,
          item,
          quantity
        );

        return;
      }


      /*
       * MINUS
       */

      if (minusButton) {

        const item = minusButton.closest('.cart-drawer__item');

        if (!item) return;

        const quantityElement =
          item.querySelector('.cart-quantity-number');

        const quantity =
          parseInt(quantityElement.textContent, 10) || 0;

        const newQuantity =
          Math.max(quantity - 1, 0);

        updateCartItem(
          minusButton.dataset.key,
          newQuantity,
          item,
          quantity
        );

        return;
      }


      /*
       * REMOVE
       */

      if (removeButton) {

        const item =
          removeButton.closest('.cart-drawer__item');

        if (!item) return;

        const quantityElement =
          item.querySelector('.cart-quantity-number');

        const oldQuantity =
          parseInt(quantityElement.textContent, 10) || 0;

        /*
         * Immediately remove from screen.
         */

        item.style.opacity = '0';
        item.style.transform = 'translateX(20px)';
        item.style.transition =
          'opacity 0.2s ease, transform 0.2s ease';

        setTimeout(function () {

          if (item.parentNode) {
            item.remove();
          }

          checkEmptyCart();

        }, 200);

        /*
         * Update Shopify in background.
         */

        updateCartItem(
          removeButton.dataset.key,
          0,
          item,
          oldQuantity,
          true
        );

      }

    });


    /*
     * ==============================
     * UPDATE CART ITEM
     * ==============================
     */

    async function updateCartItem(
      key,
      quantity,
      itemElement,
      oldQuantity,
      wasRemoved = false
    ) {

      /*
       * Disable only the clicked item's buttons
       * while Shopify processes the request.
       */

      const buttons =
        itemElement
          ? itemElement.querySelectorAll('button')
          : [];

      buttons.forEach(function (button) {
        button.disabled = true;
      });


      /*
       * Optimistic quantity update
       */

      if (
        itemElement &&
        !wasRemoved
      ) {

        const quantityElement =
          itemElement.querySelector('.cart-quantity-number');

        if (quantityElement) {
          quantityElement.textContent = quantity;
        }

      }


      try {

        const response = await fetch(
          window.Shopify.routes.root + 'cart/change.js',
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },

            body: JSON.stringify({
              id: key,
              quantity: quantity
            })
          }
        );


        if (!response.ok) {
          throw new Error('Cart update failed');
        }


        /*
         * IMPORTANT:
         *
         * /cart/change.js already returns
         * the updated cart.
         *
         * Therefore we DON'T call /cart.js again.
         */

        const cart = await response.json();

        updateCartUI(cart);

      } catch (error) {

        console.error('Cart update error:', error);

        /*
         * Restore UI if Shopify update fails.
         */

        if (itemElement) {

          if (wasRemoved) {

            /*
             * The item was removed visually.
             * Restore it by reloading the cart.
             */

            await loadCart();

          } else {

            const quantityElement =
              itemElement.querySelector(
                '.cart-quantity-number'
              );

            if (quantityElement) {
              quantityElement.textContent =
                oldQuantity;
            }

          }

        }

      } finally {

        buttons.forEach(function (button) {
          button.disabled = false;
        });

      }

    }


    /*
     * ==============================
     * UPDATE ONLY CART UI
     * ==============================
     */

    function updateCartUI(cart) {

      /*
       * Update subtotal immediately.
       */

      if (subtotalElement) {

        subtotalElement.textContent =
          formatMoney(cart.total_price);

      }


      /*
       * If cart is empty
       */

      if (cart.item_count === 0) {

        itemsContainer.innerHTML = `
          <div class="cart-drawer__empty">
            <p>Your cart is empty.</p>
          </div>
        `;

        return;
      }


      /*
       * Update quantities of existing items.
       *
       * We don't rebuild the entire drawer.
       */

      cart.items.forEach(function (cartItem) {

        const itemElement =
          itemsContainer.querySelector(
            `[data-cart-item-key="${CSS.escape(cartItem.key)}"]`
          );

        if (!itemElement) return;

        const quantityElement =
          itemElement.querySelector(
            '.cart-quantity-number'
          );

        if (quantityElement) {

          quantityElement.textContent =
            cartItem.quantity;

        }


        const priceElement =
          itemElement.querySelector(
            '.cart-item-price'
          );

        if (priceElement) {

          priceElement.textContent =
            formatMoney(cartItem.final_line_price);

        }

      });

    }


    /*
     * ==============================
     * CHECK EMPTY CART
     * ==============================
     */

    function checkEmptyCart() {

      const items =
        itemsContainer.querySelectorAll(
          '.cart-drawer__item'
        );

      if (items.length === 0) {

        itemsContainer.innerHTML = `
          <div class="cart-drawer__empty">
            <p>Your cart is empty.</p>
          </div>
        `;

        if (subtotalElement) {
          subtotalElement.textContent =
            formatMoney(0);
        }

      }

    }


    /*
     * ==============================
     * INITIAL CART RENDER
     * ==============================
     */


    function renderCart(cart) {

      if (!itemsContainer || !footerElement) return;

      // Keep footer visibility synchronized with Shopify's cart.
      footerElement.hidden = cart.item_count === 0;

      // Render empty cart.
      if (cart.item_count === 0) {

        itemsContainer.innerHTML = `
          <div class="cart-drawer__empty">
            <p>Your cart is empty.</p>
          </div>
        `;

        if (subtotalElement) {
          subtotalElement.textContent = formatMoney(cart.total_price);
        }

        return;
      }

      // Render all cart items.
      itemsContainer.innerHTML = cart.items.map(function (item) {

        return `
          <div
            class="cart-drawer__item"
            data-cart-item-key="${escapeAttribute(item.key)}"
          >

            <div class="cart-drawer__image">
              ${
                item.image
                  ? `
                    <img
                      src="${escapeAttribute(item.image)}"
                      alt="${escapeAttribute(item.product_title)}"
                      width="80"
                      height="80"
                    >
                  `
                  : ''
              }
            </div>

            <div class="cart-drawer__info">

              <h3>${escapeHtml(item.product_title)}</h3>

              <p class="cart-item-price">
                ${formatMoney(item.final_line_price)}
              </p>

              <div class="cart-drawer__quantity">

                <button
                  type="button"
                  class="cart-quantity-minus"
                  data-key="${escapeAttribute(item.key)}"
                >−</button>

                <span class="cart-quantity-number">
                  ${item.quantity}
                </span>

                <button
                  type="button"
                  class="cart-quantity-plus"
                  data-key="${escapeAttribute(item.key)}"
                >+</button>

              </div>

              <button
                type="button"
                class="cart-remove"
                data-key="${escapeAttribute(item.key)}"
              >Remove</button>

            </div>

          </div>
        `;

      }).join('');

      // Update subtotal.
      if (subtotalElement) {
        subtotalElement.textContent = formatMoney(cart.total_price);
      }

      // Explicitly make the footer visible.
      footerElement.hidden = false;
      footerElement.style.removeProperty('display');
    }




    /*
     * ==============================
     * MONEY
     * ==============================
     */

    function formatMoney(cents) {

      const currency =
        window.Shopify &&
        Shopify.currency &&
        Shopify.currency.active
          ? Shopify.currency.active
          : 'AED';

      return new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        {
          style: 'currency',
          currency: currency
        }
      ).format(cents / 100);

    }


    /*
     * ==============================
     * ESCAPE HTML
     * ==============================
     */

    function escapeHtml(value) {

      const div =
        document.createElement('div');

      div.textContent =
        value || '';

      return div.innerHTML;

    }


    /*
     * ==============================
     * ESCAPE ATTRIBUTE
     * ==============================
     */

    function escapeAttribute(value) {

      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    }


    /*
     * ==============================
     * LOAD CURRENT CART
     * ==============================
     */

    loadCart();

  }


  /*
   * If DOM is already ready,
   * initialize immediately.
   */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initCartDrawer
    );

  } else {

    initCartDrawer();

  }

})();